import { apiRequest } from "../api/client";

export type PublicCrmBillingInterval = "MONTHLY" | "ANNUAL";

export interface PublicCrmPrice {
  billing_interval: PublicCrmBillingInterval;
  currency: string;
  amount_minor_units: number;
}

export interface PublicCrmPricing {
  available: boolean;
  plan: {
    code: string;
    name: string;
    description?: string | null;
    base_included_seats: number;
    prices: PublicCrmPrice[];
    founding_offer?: {
      label: string;
      available: boolean;
      prices: PublicCrmPrice[];
    } | null;
  };
}

export function fetchPublicCrmPricing(): Promise<PublicCrmPricing> {
  return apiRequest<PublicCrmPricing>("/api/billing/public/crm-pricing");
}

export function publicCrmPrice(
  prices: PublicCrmPrice[],
  interval: PublicCrmBillingInterval,
): PublicCrmPrice | undefined {
  return prices.find((price) => price.billing_interval === interval);
}

export function publicCrmAmountLabel(price?: PublicCrmPrice): string {
  if (!price) return "Pricing unavailable";
  const amount = Number(price.amount_minor_units) / 100;
  try {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: price.currency,
      maximumFractionDigits: 0,
    }).format(amount);
  } catch {
    return `${price.currency} ${amount.toLocaleString("en-IN")}`;
  }
}

